import { render, staticRenderFns } from "./UserNavigation.vue?vue&type=template&id=1d68ba1e&scoped=true"
import script from "./UserNavigation.vue?vue&type=script&lang=js"
export * from "./UserNavigation.vue?vue&type=script&lang=js"
import style0 from "./UserNavigation.vue?vue&type=style&index=0&id=1d68ba1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d68ba1e",
  null
  
)

export default component.exports